import { render, staticRenderFns } from "./HubHandler.vue?vue&type=template&id=0b1ec223&scoped=true&"
import script from "./HubHandler.vue?vue&type=script&lang=js&"
export * from "./HubHandler.vue?vue&type=script&lang=js&"
import style0 from "./HubHandler.vue?vue&type=style&index=0&id=0b1ec223&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ec223",
  null
  
)

export default component.exports